<script setup lang="ts">
definePageMeta({
  layout: 'loggedout'
})
</script>

<template>
  <div class="w-full">
    <div class="text-center">
      <div class="mb-8">
        <h1 class="text-4xl font-bold mb-2 text-white">Crow Gifts</h1>
        <p class="text-gray-400">Collect and share your crow treasures</p>
      </div>

      <div class="space-y-6 mb-8">
        <a href="/oauth/google" class="flex items-center justify-center gap-3 w-full bg-white text-gray-900 hover:bg-gray-100 font-bold py-4 px-6 rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" class="w-6 h-6 !m-0" alt="Google" />
          <span>Continue with Google</span>
        </a>
      </div>

      <div class="pt-6 border-t border-gray-800">
        <p class="text-sm text-gray-500">
          Made with 💜 by t-witchy
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  margin: 0 !important;
}
</style>
